'use client';

import { useRef } from 'react';
import { parseAsStringLiteral, useQueryState } from 'nuqs';
import { HistoryType } from 'src/@types/historyTables';
import {
	PORTFOLIO_HISTORY_TABS,
	PORTFOLIO_HISTORY_DEFAULT_TAB,
	PORTFOLIO_HISTORY_TABS_VALUES,
} from 'src/components/PortfolioPage/PortfolioHistorySubPage/consts';
import Tabs from 'src/components/primitives/Tabs/Tabs';
import ScrollShadows from 'src/components/ScrollShadows';
import useIsMobileScreenSize from 'src/hooks/useIsMobileScreenSize';
import PortfolioHistoryBalancesTable from 'src/components/PortfolioPage/PortfolioHistorySubPage/PortfolioHistoryBalancesTable/PortfolioHistoryBalancesTable';
import PortfolioHistoryOrdersTable from 'src/components/PortfolioPage/PortfolioHistorySubPage/PortfolioHistoryOrdersTable';
import PortfolioHistoryTradesTable from 'src/components/PortfolioPage/PortfolioHistorySubPage/PortfolioHistoryTradesTable/PortfolioHistoryTradesTable';
import PortfolioHistoryFundingTable from 'src/components/PortfolioPage/PortfolioHistorySubPage/PortfolioHistoryFundingTable/PortfolioHistoryFundingTable';
import PortfolioHistoryRewardsTable from 'src/components/PortfolioPage/PortfolioHistorySubPage/PortfolioHistoryRewardsTable/PortfolioHistoryRewardsTable';
import PortfolioHistoryLiquidationsTable from 'src/components/PortfolioPage/PortfolioHistorySubPage/PortfolioHistoryLiquidationsTable/PortfolioHistoryLiquidationsTable';
import PortfolioHistoryIFStakingTable from 'src/components/PortfolioPage/PortfolioHistorySubPage/PortfolioHistoryIFStakingTable/PortfolioHistoryIFStakingTable';
import PortfolioHistorySettledTable from 'src/components/PortfolioPage/PortfolioHistorySubPage/PortfolioHistorySettledTable/PortfolioHistorySettledTable';
import PortfolioHistoryExportsTable from 'src/components/PortfolioPage/PortfolioHistorySubPage/PortfolioHistoryExportsTable/PortfolioHistoryExportsTable';
import PortfolioHistoryPositionsTable from 'src/components/PortfolioPage/PortfolioHistorySubPage/PortfolioHistoryPositionsTable/PortfolioHistoryPositionsTable';

export default function PortfolioHistorySubPage() {
	const [activeTab, setActiveTab] = useQueryState<HistoryType>(
		'table',
		parseAsStringLiteral(PORTFOLIO_HISTORY_TABS_VALUES)
			.withDefault(PORTFOLIO_HISTORY_DEFAULT_TAB)
			.withOptions({ clearOnDefault: false })
	);
	const scrollableRef = useRef<HTMLDivElement>(null);
	const isMobileScreenSize = useIsMobileScreenSize();

	return (
		<>
			<ScrollShadows
				className="w-full"
				scrollableRef={scrollableRef}
				gradientFromClassName="from-main-bg"
			>
				<div className="hidden-scroll overflow-x-auto" ref={scrollableRef}>
					<Tabs
						variant="secondary"
						size={isMobileScreenSize ? 'sm' : 'md'}
						className="w-fit"
						options={PORTFOLIO_HISTORY_TABS}
						activeTab={activeTab}
						onTabChange={setActiveTab}
						dataTestId="portfolio-history-tabs"
						tabTestIdPrefix="portfolio-history-tab"
					/>
				</div>
			</ScrollShadows>
			{activeTab === 'deposits' && <PortfolioHistoryBalancesTable />}
			{activeTab === 'orders' && <PortfolioHistoryOrdersTable />}
			{activeTab === 'trades' && <PortfolioHistoryTradesTable />}
			{activeTab === 'positions' && <PortfolioHistoryPositionsTable />}
			{activeTab === 'funding-payments' && <PortfolioHistoryFundingTable />}
			{activeTab === 'rewards' && <PortfolioHistoryRewardsTable />}
			{activeTab === 'liquidations' && <PortfolioHistoryLiquidationsTable />}
			{activeTab === 'if-staking' && <PortfolioHistoryIFStakingTable />}
			{activeTab === 'settled-balances' && <PortfolioHistorySettledTable />}
			{activeTab === 'exports' && <PortfolioHistoryExportsTable />}
		</>
	);
}
